import React from 'react';

const JS_Syllabus = () => {
  return (
    <div >
      <h1>JS_Syllabus</h1>
      <p>Placeholder component for: "JS Syllabus"</p>
    </div>
  );
};

export default JS_Syllabus;
